import { useCallback, useEffect, useState } from 'react';

const TABLET_WIDTH = 1200;
const MOBILE_WIDTH = 568;

const useResponsive = () => {
  const [isTablet, setIsTablet] = useState(window.innerWidth > MOBILE_WIDTH
    && window.innerWidth <= TABLET_WIDTH);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_WIDTH);

  const handleResize = useCallback(() => {
    setIsTablet(window.innerWidth > MOBILE_WIDTH
      && window.innerWidth <= TABLET_WIDTH);
    setIsMobile(window.innerWidth <= MOBILE_WIDTH);
  }, []);

  useEffect(() => {
    handleResize();

    window.addEventListener('resize',
      handleResize);

    return () => {
      window.removeEventListener('resize',
        handleResize);
    };
  }, [handleResize]);

  return ({
    isMobile,
    isTablet,
  });
};

export { useResponsive };
